import React from "react";
import { ChallengeRewardDetail } from "types/globalTypes";
import { Table } from "antd";
import moment from "moment-timezone";

enum ColumnKey {
  Name = "name",
  EligibilityDateRange = "eligibilityDateRange",
  Amount = "amount",
  Status = "status",
}

interface ChallengeRewardsProps {
  challengeRewards: ChallengeRewardDetail[];
  loading: boolean;
}

export const ChallengeRewards: React.FC<ChallengeRewardsProps> = ({
  challengeRewards,
  loading,
}) => (
  <div>
    <Table
      size="small"
      loading={loading}
      pagination={false}
      dataSource={challengeRewards}
      rowKey={({ id }) => id}
      columns={[
        { title: "Name", key: ColumnKey.Name, dataIndex: ColumnKey.Name },
        {
          title: "Eligibility Dates",
          key: ColumnKey.EligibilityDateRange,
          render: (_, { eligibilityStartDate, eligibilityEndDate }) =>
            `${moment(eligibilityStartDate).format("ll")} - ${moment(
              eligibilityEndDate,
            ).format("ll")}`,
        },
        {
          title: "Amount",
          key: ColumnKey.Amount,
          dataIndex: ColumnKey.Amount,
          render: (amount) => <>${amount}</>,
        },
        { title: "Status", key: ColumnKey.Status, dataIndex: ColumnKey.Status },
      ]}
    />
  </div>
);

export default ChallengeRewards;
